// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_be-3";
export var contentContainer = "_be-0";
export var editorContainer = "_be-1";
export var quillInputForm = "_be-2";
export var zoneDivider = "_be-4";